module.exports = __webpack_public_path__ + "static/img/2.c344b7f7.png";